// extracted by mini-css-extract-plugin
export var wordContainer = "_n7-0";